import * as Localization from "expo-localization";
import { APP_SLUG, IS_PRODUCTION, manifest } from "../constants";
import { logout } from "../hooks/useLogout";
import { createApolloCacheBase, createApolloClientBase } from "./apolloClientBase";
import { authClient } from "./auth";
export var createApolloCache = createApolloCacheBase;
export var createApolloClient = function(uri) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, subscriptionUri = _ref.subscriptionUri, _ref_connectToDevTools = _ref.connectToDevTools, connectToDevTools = _ref_connectToDevTools === void 0 ? false : _ref_connectToDevTools, _getAuthHeader = _ref.getAuthHeader, _ref_cache = _ref.cache, cache = _ref_cache === void 0 ? createApolloCache() : _ref_cache, _ref_defaultOptions = _ref.defaultOptions, defaultOptions = _ref_defaultOptions === void 0 ? {} : _ref_defaultOptions;
    var _Localization_getCalendars_, _Localization_getLocales_;
    var _Localization_getCalendars__timeZone;
    return createApolloClientBase({
        uri: uri,
        subscriptionUri: subscriptionUri,
        isProduction: IS_PRODUCTION,
        onLogout: logout,
        clientName: APP_SLUG,
        clientVersion: manifest.version,
        clientTimezone: (_Localization_getCalendars__timeZone = (_Localization_getCalendars_ = Localization.getCalendars()[0]) === null || _Localization_getCalendars_ === void 0 ? void 0 : _Localization_getCalendars_.timeZone) !== null && _Localization_getCalendars__timeZone !== void 0 ? _Localization_getCalendars__timeZone : undefined,
        clientLocale: (_Localization_getLocales_ = Localization.getLocales()[0]) === null || _Localization_getLocales_ === void 0 ? void 0 : _Localization_getLocales_.languageTag,
        getAuthHeader: _getAuthHeader || function() {
            return authClient.getAuthorizationHeader();
        },
        connectToDevTools: connectToDevTools,
        cache: cache
    });
};
